// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"4ed7c3fa","703":"9ac371f3"}[chunkId] + ".chunk.js";
};